import { L, vocabulary } from '../define.js';
export const RISK_VOCABULARIES = [
    vocabulary('risk.risk_action', '@vello/risk RISK_ACTIONS', {
        ALLOW: L('Permitir', 'Allow', 'Permitir', 'Consentire'),
        CHALLENGE: L('Pedir confirmação extra', 'Ask for extra verification', 'Pedir verificación extra', 'Chiedere una verifica aggiuntiva'),
        SELFIE: L('Pedir selfie', 'Ask for a selfie', 'Pedir selfie', 'Chiedere un selfie'),
        REQUIRE_CARD: L('Exigir cartão', 'Require a card', 'Exigir tarjeta', 'Richiedere la carta'),
        BLOCK_CASH: L('Bloquear dinheiro', 'Block cash', 'Bloquear efectivo', 'Bloccare i contanti'),
        HOLD_PAYOUT: L('Reter repasse', 'Hold payout', 'Retener liquidación', 'Trattenere il pagamento'),
        REVIEW: L('Enviar para análise', 'Send for review', 'Enviar a revisión', 'Inviare in revisione'),
        SUSPEND: L('Suspender', 'Suspend', 'Suspender', 'Sospendere'),
    }),
    vocabulary('risk.risk_case_status', '@vello/risk RISK_CASE_STATUSES', {
        OPEN: L('Aberto', 'Open', 'Abierto', 'Aperto'),
        UNDER_REVIEW: L('Em análise', 'Under review', 'En revisión', 'In revisione'),
        CONFIRMED: L('Confirmado', 'Confirmed', 'Confirmado', 'Confermato'),
        DISMISSED: L('Arquivado', 'Dismissed', 'Descartado', 'Archiviato'),
        APPEALED: L('Contestado', 'Appealed', 'Apelado', 'Contestato'),
        OVERTURNED: L('Revertido', 'Overturned', 'Revertido', 'Annullato'),
        UPHELD: L('Mantido', 'Upheld', 'Mantenido', 'Confermato'),
    }),
    vocabulary('risk.risk_source', '@vello/risk RISK_SOURCES', {
        DEVICE: L('Aparelho', 'Device', 'Dispositivo', 'Dispositivo'),
        IP: L('Endereço de rede (IP)', 'Network address (IP)', 'Dirección de red (IP)', 'Indirizzo di rete (IP)'),
        ACCOUNT_GRAPH: L('Ligações entre contas', 'Account links', 'Vínculos entre cuentas', 'Collegamenti tra account'),
        PAYMENT: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
        LOCATION: L('Localização', 'Location', 'Ubicación', 'Posizione'),
        TRIP: L('Corrida', 'Ride', 'Viaje', 'Corsa'),
        DOCUMENT: L('Documento', 'Document', 'Documento', 'Documento'),
        PROMO: L('Promoção', 'Promotion', 'Promoción', 'Promozione'),
    }),
];
//# sourceMappingURL=risk.js.map